import React from 'react';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";

import * as ResourceApi from "api/resources";
import {createButtonSectionFactoryWithAdditionalArgs, createButtonSectionFactory} from "hoc/CreateButtonSection";

export default {
    key: "breakFooterLinksSection",
    props: {
        getInnerHeader: () => "Footer Links"
    },
    fields: [
        // {
        //     type: 'hardcodedText',
        //     key: "content-network-intro",
        //     props: {
        //       text: 'This section allows you to control which sites this break will be published to and how the content is categorized on each site.',
        //     }
        // },

        {
            name: 'footerLinks',
            resource: true,
            subSection: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
                // console.log(`formProxy.currentResource`, formProxy.currentResource)
                return true;
            },
            sortable: true,
            sortableName: "breakFooterLinksOrder",
            // toggleSortLabelKey: 'editbreak.steps.receipt_verification.instruction.reorder_toggle',
            resourceType: ResourceApi.Types.BreakFooterLink,

            props: {
                // headerKey: 'editbreak.steps.receipt.instruction.header',
                getCustomSectionHeader: (link, sectionIndex) => {
                    return "Link " + (sectionIndex + 1) + ((link.label) ? ": " + link.label : "");
                }
            },

            footerContent: createButtonSectionFactory(ResourceApi.Types.BreakFooterLink),

            fields: [
                        {
                            type: "contenteditable",
                            name: "label",
                            required: false,
                            props: {
                                labelKey: "Label",
                            },
                        },
                        {
                            type: 'dropdown',
                            name: 'type',
                            required: true,
                            props: {
                                labelKey: 'Type',
                                defaultValue: 'URL',
                                options: [
                                    {
                                        value: null,
                                        textKey: 'Select Type'
                                    },
                                    {
                                        value: 'URL',
                                        textKey: 'URL'
                                    },
                                    {
                                        value: 'ACTION',
                                        textKey: 'Action'
                                    },
                                    {
                                        value: 'JAVASCRIPT_CODE',
                                        textKey: 'Execute JavaScript Code'
                                    }
                                ]
                            }
                        },
                        {
                            type: "text",
                            name: "url",
                            required: false,
                            showField: (proxy) => (proxy.currentResource.type === 'URL'),
                            props: {
                                labelKey: "Url",
                            },
                        },
                        {
                            type: 'dropdown',
                            name: 'action',
                            required: false,
                            showField: (proxy) => (proxy.currentResource.type === 'ACTION' && proxy.currentResource.type !== 'JAVASCRIPT_CODE'),
                            props: {
                                labelKey: 'Action',
                                options: [
                                    {
                                        value: null,
                                        textKey: 'Select Action'
                                    },
                                    {
                                        value: 'COOKIE_BANNER',
                                        textKey: 'Open Cookie Banner'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'textarea',
                            name: 'action',
                            required: false,
                            showField: (proxy) => (proxy.currentResource.type === 'JAVASCRIPT_CODE'),
                            props: {
                                labelKey: 'JavaScript Code',
                            },
                        }
            ]        
        },
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksFooterLinksSection.js